"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var react_1 = __importStar(require("react"));
var index_1 = require("../CookieConsent/index");
var CookieConsentSidebarItem_1 = __importDefault(require("./CookieConsentSidebarItem"));
var useStyles = (0, makeStyles_1.default)({
    spacer: {
        flexGrow: 1,
    },
    logoContainer: {
        textAlign: 'center',
        height: 32,
        '&:last-child': {
            marginBottom: 12,
        },
    },
    logo: {
        height: '100%',
    },
});
var SidebarBody = function (_a) {
    var children = _a.children, logo = _a.logo;
    var classes = useStyles();
    var cookieConsentContext = (0, react_1.useContext)(index_1.CookieConsentContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement("div", { className: classes.spacer }),
        !cookieConsentContext.disabled && react_1.default.createElement(CookieConsentSidebarItem_1.default, null),
        react_1.default.createElement("div", { className: classes.logoContainer },
            react_1.default.createElement("a", { href: "https://realcity.io", target: "_blank", rel: "noopener noreferrer" },
                react_1.default.createElement("img", { className: classes.logo, src: logo, alt: "logo", title: "Powered by realCity" })))));
};
exports.default = SidebarBody;
